import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import {
  isInvalidDate,
  isValidNumberRequired,
  getErrorsAdresse,
  genererObjectErrorAdresse,
} from '@/services/general/validations';
import { getPropertyPaths } from '@/services/general/general';

export const genererObjectErrorBudget = () => ({
  dateFin: false,
  dateDebut: false,
  dateFinPremiereEcheance: false,
  prixNet: false,
  prixBrutNegocie: false,
  periodesChevauche: false,
  prixUnitaireBrut: false,
  quantiteBrut: false,
  uniteQteBrut: false,
  prixUnitaireTlpe: false,
  quantiteTlpe: false,
  uniteQteTlpe: false,
});

export function controleBudget(bg, errorBudget, isGeneration = false) {
  errorBudget.dateDebut = isInvalidDate(bg.dateDebut, true);
  errorBudget.dateFin = isInvalidDate(bg.dateFin, true);

  if (!errorBudget.dateDebut && !errorBudget.dateFin) {
    if (!moment(bg.dateFin).isAfter(moment(bg.dateDebut))) {
      errorBudget.dateDebut = true;
      errorBudget.dateFin = true;
    }
  }

  if (bg.dateFinPremiereEcheance) {
    const d = moment(bg.dateFinPremiereEcheance);
    const isAfterDebut = d.isAfter(moment(bg.dateDebut));
    const isBeforeFin = d.isBefore(moment(bg.dateFin));
    errorBudget.dateFinPremiereEcheance = !isAfterDebut || !isBeforeFin;
  }

  errorBudget.prixBrutNegocie = !isValidNumberRequired(bg.prixBrutNegocie);
  errorBudget.prixNet = !isValidNumberRequired(bg.prixNet);

  if (!isGeneration) {
    errorBudget.prixUnitaireBrut = !isValidNumberRequired(bg.prixUnitaireBrut);
    errorBudget.quantiteBrut = !isValidNumberRequired(bg.quantiteBrut);
    errorBudget.uniteQteBrut = !bg.uniteQteBrut;
    errorBudget.prixUnitaireTlpe = !isValidNumberRequired(bg.prixUnitaireTlpe);
    errorBudget.quantiteTlpe = !isValidNumberRequired(bg.quantiteTlpe);
    errorBudget.uniteQteTlpe = !bg.uniteQteTlpe;
  }
}

function controleChevauchemntPeriodes(budgets, errorBudgets) {
  if (budgets.length < 2) return;
  const sorted = [...budgets]
    .filter(b => b.dateDebut && b.dateFin)
    .sort((a, b) => moment(a.dateDebut).valueOf() - moment(b.dateDebut).valueOf());

  for (let i = 1; i < sorted.length; i += 1) {
    const prev = sorted[i - 1];
    const curr = sorted[i];
    if (moment(curr.dateDebut).isBefore(moment(prev.dateFin))) {
      if (errorBudgets[prev.guid]) errorBudgets[prev.guid].periodesChevauche = true;
      if (errorBudgets[curr.guid]) errorBudgets[curr.guid].periodesChevauche = true;
    }
  }
}

export function isValidPanneau(panneau, error = genererObjectError()) {
  error.regie = !panneau.regie;
  error.referenceConfrere = !panneau.referenceConfrere;
  error.format = !panneau.format;
  error.materiel = !panneau.materiel;
  error.categorie = isEmpty(panneau.categorie);
  error.disposition = (panneau.disposition || '').length > 50;
  error.pourcentageSurface = !isValidNumberRequired(panneau.pourcentageSurface)
    || panneau.pourcentageSurface < 0 || panneau.pourcentageSurface > 100;
  error.adresse = getErrorsAdresse(panneau.adresse);
  error.adresseError = Object.values(error.adresse).some(Boolean);

  controleBudget(panneau.budgetGeneration, error.budgetGeneration, true);

  if (panneau.budgets.length >= 1) {
    error.budgetGeneration.prixBrutNegocie = false;
    error.budgetGeneration.prixNet = false;
  }

  Object.keys(error.budgets).forEach(key => {
    const budget = panneau.budgets.find(b => b.guid === key);
    if (!budget) return;
    controleBudget(budget, error.budgets[key]);
  });

  controleChevauchemntPeriodes(panneau.budgets, error.budgets);

  error.noBudgets = panneau.budgets.length < 1;

  const hasErrorGeneral = Object.values(error).filter(el => typeof el === 'boolean').some(Boolean);
  const hasErrorBudgetGeneration = Object.values(error.budgetGeneration).some(Boolean);
  const hasErrorBudgets = Object.values(error.budgets).some(budgetError => Object.values(budgetError).some(Boolean));
  return !hasErrorGeneral
    && !hasErrorBudgetGeneration
    && !hasErrorBudgets;
}

export function getMsgErrorPanneau(error) {
  const excludedKeys = ['adresseError', 'budgets', 'budgetGeneration'];
  return getPropertyPaths(error)
    .filter(key => !excludedKeys.some(el => key.startsWith(el)) && get(error, key))
    .map(key => `creerPanneau.error.${key}`);
}

export function getMsgErrorBudget(errorBudget) {
  return getPropertyPaths(errorBudget)
    .filter(key => get(errorBudget, key))
    .map(key => `creerPanneau.error.budgetGeneration.${key}`);
}

export const genererObjectError = () => ({
  regie: false,
  referenceConfrere: false,
  format: false,
  materiel: false,
  categorie: false,
  disposition: false,
  pourcentageSurface: false,
  noBudgets: false,
  adresseError: false,
  adresse: genererObjectErrorAdresse(),
  budgetGeneration: genererObjectErrorBudget(),
  budgets: {},
});

export const genererObjectErrorBudgets = (budgets) => budgets.reduce((acc, budget) => {
  acc[budget.guid] = genererObjectErrorBudget();
  return acc;
}, {});
